import {Component, input} from '@angular/core';
import {TranslocoDirective} from "@jsverse/transloco";
import {NgOptimizedImage} from "@angular/common";
import {getLoyaltyLevel, PillLogoComponent, PillLoyaltyComponent, Size} from "shared-lib";

@Component({
  selector: 'app-first-page',
  imports: [TranslocoDirective, NgOptimizedImage, PillLogoComponent, PillLoyaltyComponent],
  templateUrl: './first-page.component.html',
  styleUrl: './first-page.component.scss'
})
export class FirstPageComponent {
  companyName = input.required<string>();
  loyaltyScore = input.required<number>();
  companyLogo = input.required<string>();
  protected readonly getLoyaltyLevel = getLoyaltyLevel;
  protected readonly Size = Size;
}
